import { useState } from 'react'

import { Button, Heading, Text } from '@ankor-io/ui-components'

import { FeatureFlagsTable } from '@/components/feature-flags/feature-flags-table'

export function FeatureFlags() {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <div className="space-y-6">
      <div className="flex md:items-center justify-between gap-2 flex-col md:flex-row">
        <div>
          <Heading level={3}>Feature Flags</Heading>
          <Text className="mt-2 text-gray-600 dark:text-gray-400">
            Manage global features and their default availability
          </Text>
        </div>

        <Button
          className="w-full md:w-auto"
          color="primary"
          onClick={() => setIsDialogOpen(true)}
        >
          New Feature Flag
        </Button>
      </div>

      <FeatureFlagsTable
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
      />
    </div>
  )
}

export default FeatureFlags
